import { getJson } from '@rad/utility/http';
export const getAnalyticsReport = (days) => getJson('/api/analytics/v1/report', { days });
export const getApplicationReport = (applicationId, days, search, eventName) => getJson(`/api/analytics/v1/report/applications/${encodeURIComponent(applicationId)}`, {
    days,
    'q': search || undefined,
    'event': eventName || undefined,
});
export const getSessionReport = (sessionId) => getJson(`/api/analytics/v1/report/sessions/${encodeURIComponent(sessionId)}`);
export const getCatalog = () => getJson('/apps.json');
